import { useTranslation } from "react-i18next";
import Button from "shared/UI/Buttons/Button";

interface NotSureRoutingCoachmarkProps {
  step: number;
  totalSteps: number;
  onSkip: () => void;
  onNext: () => void;
}

export const NotSureRoutingCoachmark = ({ step, totalSteps, onSkip, onNext }: NotSureRoutingCoachmarkProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: "supportMoments.notSureRouting.coachmark" });

  return (
    <div className="space-y-2 p-3 max-w-[355px] lg:w-[327px]">
      <h3 className="!text-lg">{t("heading")}</h3>
      <p className="text-lg">{t("body")}</p>
      <div className="flex items-center justify-between pt-6">
        <span>{t("stepIndicator", { current: step, count: totalSteps })}</span>
        <div className=" flex items-center gap-3">
          <Button
            type="button"
            onClick={onSkip}
            className="rounded-full bg-white hover:bg-white !text-navy-blue !font-light !w-[90px] !h-[35px]"
            text={t("skip")}
          />
          <Button type="button" onClick={onNext} variant="secondary" className="rounded-full !w-[90px] !h-[35px]" text={t("next")} />
        </div>
      </div>
    </div>
  );
};
